export const HOURLY_PAY_RATE = 11.44;